import { Heart, Home, Package, ShoppingBag, ShoppingCart, User } from "lucide-react";

export const customerMenuData: any[] = [
  {
    id: "customer-home",
    label: "Home",
    link: "/customer/dashboard",
    icon: <Home />,
  },
  {
    id: "customer-catalog",
    label: "Catalog",
    link: "/customer/catalog",
    icon: <Package />,
  },
  {
    id: "customer-products",
    label: "Products",
    link: "/customer/products",
    icon: <ShoppingBag />,
  },
  {
    id: "customer-cart",
    label: "Cart",
    link: "/customer/cart",
    icon: <ShoppingCart />,
  },
  {
    id: "customer-wishlist",
    label: "Wishlist",
    link: "/customer/wishlist",
    icon: <Heart />,
  },
  {
    id: "customer-orders",
    label: "Orders",
    link: "/customer/orders",
    icon: <Package />,
  },
  {
    id: "customer-profile",
    label: "Profile",
    link: "/customer/profile",
    icon: <User />,
  },
];
